import { transcludeWithComponentModule } from '../transclude-with/transclude-with';
import { asSortableHelperModule } from '../../helpers/as-sortable-helper';
import simplerRepeaterTemplate from './simple-repeater.tpl.html';
import './simple-repeater.less';
import { defineValue } from '../../utils/object-utils/object-utils';

let repeaterCounter = 0;

export const simpleRepeaterComponentModule = angular
  .module('Q.components.simple-repeater', [
    transcludeWithComponentModule,
    asSortableHelperModule,
  ])

  .component('simpleRepeater', {
    restrict: 'E',
    transclude: {
      row: 'itemContent',
      header: '?repeaterHeader',
      footer: '?repeaterFooter',
    },
    template: simplerRepeaterTemplate,
    bindings: {
      items: '=ngModel',
      itemKey: '@',
      itemLabel: '@',
      blankItem: '<',
      sortable: '<',
      onAdd: '&',
      onRemove: '&',
      onSort: '&',
    },
    require: {
      ngModel: 'ngModel',
    },
    controller: 'SimpleRepeaterCtrl',
  })

  .controller(
    'SimpleRepeaterCtrl',
    function SimpleRepeaterCtrl(asSortableHelper, $timeout, $element) {
      const ctrl = this;

      repeaterCounter++;
      ctrl.counter = repeaterCounter;

      // if a string then track by index otherwise try to track by a model id and fall back to creating a new id
      ctrl._trackBy = function (item, index) {
        if (!angular.isObject(item)) {
          return index;
        } else if (item.id || item._id) {
          return item.id || item._id;
        } else {
          defineValue(item, '_id', Math.random().toString(16).substr(2));
          return item._id;
        }
      };

      ctrl._sortable = asSortableHelper.autoScroll({
        containment: '#simple-repeater-' + ctrl.counter,
        containerPositioning: 'relative',
        accept(sourceItemHandleScope, destSortableScope) {
          return (
            sourceItemHandleScope.itemScope.sortableScope.$id ===
            destSortableScope.$id
          );
        },
        orderChanged() {
          ctrl.onSort();
          ctrl.ngModel.$setDirty();
        },
      });

      ctrl.addItem = () => {
        let newItem = angular.copy(ctrl.blankItem);
        if (newItem === undefined) {
          newItem = {};
        }
        if (!ctrl.items) {
          ctrl.items = [];
          ctrl.ngModel.$setViewValue(ctrl.items);
        }
        ctrl.items.push(newItem);
        ctrl.ngModel.$setDirty();

        ctrl.onAdd(newItem);

        $timeout(() => {
          let newChild = $element[0].querySelector(
            '.repeater-items > :last-child > .repeater-content',
          );
          let inputs = newChild.querySelectorAll('input,textarea,select');
          if (inputs.length) {
            let firstInput = null;
            angular.forEach(inputs, (input) => {
              if (
                !firstInput &&
                input.focus &&
                input.nodeName &&
                (input.nodeName.toUpperCase() !== 'INPUT' ||
                  ['checkbox', 'radio'].indexOf(input.type) === -1)
              ) {
                firstInput = input;
              }
            });
            firstInput = firstInput || inputs[0];
            if (firstInput.focus) {
              firstInput.focus();
            }
          }
        }, 250);
      };

      ctrl.removeItem = (index) => {
        if (ctrl.items && ctrl.items.length > index) {
          let item = ctrl.items[index];
          ctrl.items.splice(index, 1);
          ctrl.ngModel.$setDirty();

          ctrl.onRemove(item, index);
        }
      };
    },
  );
